export default "__VITE_ASSET__CkRXq2nz__"